module.exports = {
  language: {
    name: '中文'
  },
  header: {
    lang: 'English',
    home: '首页',
    product: '关于公司',
    video: '色母粒系列',
    news: '色粉系列',
    yiyong: '应用领域',
    about: '联系我们',
    search: '请输入产品关键字',
    langageimg: "en.png",
    product_info: '色母粒系列',
    map_info: '主要销售区域',
    product_info_detail: '产品广泛应用于BOPET/PP/PA薄膜、涤纶、锦纶纤维纺丝、管材、热成型产品、食品包装、医用包装、无纺布、各种注塑产品等领域。',
    yiyong_info: '应用领域',
    yiyong_info_detail: '产品广泛应用于BOPET/PP/PA薄膜、涤纶、锦纶纤维纺丝、管材、热成型产品、食品包装、医用包装、无纺布、各种注塑产品等领域。',
    company_info: '企业简介',
    company_c: '企业厂房',
    
  },
  footer: {
    lang: 'English',
    home: '首页',
    product: '关于公司',
    video: '色母粒系列',
    news: '色母粉系列',
    yiyong: '应用领域',
    about: '联系我们',
    concact: '地址：广东省汕头澄海区广益街道登峰路中段峰下工业区　联系电话:0754-89873673 手机:13729250750 ',
    power: 'Copyright 丰之彩颜料有限公司 2022-2030 All Right Reserved ',
    address: '版本所有 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025436045号</a>',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js